import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {flexCenter} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {ColorDot} from '../../../../../components/common/colorDot';
import {SidePanelSubSectionWrapper} from '../sidePanelSubSectionWrapper';

/*
 * Styles.
 */

const StyledInboxes = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledConvInbox = styled.div`
  ${flexCenter}
  margin-right: 8px;
`;

const StyledColorDot = styled(ColorDot)`
  margin-right: 13px;
  margin-left: 4px;
`;

const StyledInboxName = styled.div`
  font-size: ${fontSizes.medium};
`;

/*
 * Props.
 */

type SummaryInbox = {name: string; color: string};

interface SummaryInboxesProps {
  inboxes: ReadonlyArray<SummaryInbox>;
}

/*
 * Component.
 */

export const SummaryInboxes: FC<SummaryInboxesProps> = ({inboxes}) => {
  if (inboxes.length === 0) {
    return null;
  }

  return (
    <SidePanelSubSectionWrapper title={<Trans id="analytics-drawer-details-inboxes">Inboxes</Trans>}>
      <StyledInboxes>
        {inboxes.map(({name, color}) => (
          <StyledConvInbox key={name}>
            <StyledColorDot color={color} size={8} />
            <StyledInboxName>{name}</StyledInboxName>
          </StyledConvInbox>
        ))}
      </StyledInboxes>
    </SidePanelSubSectionWrapper>
  );
};
